/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const ResendEditMFAPasscode_Shared_Mutation = gql`
  mutation ResendEditMFAPasscode_Shared_Mutation(
    $input: AuthUserTwoFactorAuthenticationResendEditInput!
  ) {
    auth {
      userResendEditTwoFactorAuthentication(input: $input) {
        sent
        errors {
          message
        }
      }
    }
  }
`;

export { ResendEditMFAPasscode_Shared_Mutation };
